<template>
  <div>
    <div class="card">
      <div class="card-body">
        <div class="d-flex with-media">
          <div class="p-2 w-100">
            <div class="media">
              <img src="/static/img/test@2x.png"/>
              <div class="media-body">
                <h1>{{examInfo.title}}</h1>
                <div>
                  <span class="gray">유형</span> {{examInfo.exam_type_name}}
                      · <span class="gray">응시 인원</span> <span class="number">{{this.formatterNumber(examInfo.exam_user_cnt)}}</span>
                      · <span class="gray">공개 여부</span> {{examInfo.stat_name}}
                      · <span class="gray">카테고리</span> {{examInfo.cate_path}}
                      <template v-if="examInfo.curriculum_yn === 'Y'"> · <span class="gray">커리큘럼</span> {{examInfo.curriculum_name}}</template>
                  <br />
                  <span class="gray">생성일</span> {{this.formatterDate(examInfo.reg_dt)}}
                  <template v-if="examInfo.open_dt !== ''">·  <span class="gray">공개일</span> {{this.formatterDate(examInfo.open_dt)}}</template>
                  <template v-if="examInfo.close_dt !== '' && examInfo.close_dt !== '-'">·  <span class="gray">종료일</span> {{this.formatterDate(examInfo.close_dt)}}</template>
                </div>
              </div>
            </div>
          </div>
          <div class="p-2 ml-auto button-group">
          </div>
        </div>
      </div>
    </div>

    <div class="card second-card">
      <div class="card-body">
        <div class="d-flex">
          <div class="p-2">
            <h2>응시 인원 <span class="number mint">{{classUserData.length}}</span></h2>
          </div>
          <div class="ml-auto p-2">
            <!-- <button type="button" class="btn btn-primary addUser-middle" :disabled="this.isPdfPrintDisabled" @click="handleCommand('pdf')">성적표 일괄저장</button> -->
            <el-dropdown @command="handleCommand">
              <el-button class="btn btn-info btn-white">
                성적표 일괄저장<i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item :disabled="this.isPdfPrintDisabled" command="personal">개인 성적표</el-dropdown-item>
                <el-dropdown-item :disabled="this.isPdfPrintDisabled" command="total" v-if="examInfo.curriculum_yn === 'Y'">종합 성적표</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <button type="button" class="btn mint addUser-middle" :disabled="classUserSelection.length === 0" @click="handleCommand('send')">성적표 알림톡 보내기</button>
            <excel :name="btnExcelName" @click="downloadExcel" :loading="excelLoading"></excel>
          </div>
        </div>
      </div>
      <stone-data-table
        ref="classUser"
        class="no-left-margin small-td"
        :loading="searchLoading"
        :columns="classUserColumns"
        :data="classUserData"
        :table-props="classUserProps"
        :page-size="emptyPageSize"
        :pagination-props="emptyPaginationProps"
        @selection-change="handleSelectionChange"
        @row-click="classUserRowClickHandler">
      </stone-data-table>
    </div>

    <el-dialog title="성적표" width="1230px" :visible.sync="dialogTableVisible" append-to-body>
      <el-row>
        <el-col :span="20" class="card-body">
          <el-progress :text-inside="true" :stroke-width="40" :percentage="this.pdfProgressbarRate"></el-progress>
        </el-col>
        <el-col :span="2" class="card-body progressbar-text">
          <span class="number">{{this.pdfProgressbarText}}</span>
        </el-col>
        <el-col :span="2" class="card-body text-right">
          <el-button class="pdf circle" type="primary" :loading="pdfLoading" @click="handlePDF"><i class="fas fa-file-pdf"></i></el-button>
        </el-col>
      </el-row>
      <R010202 ref="printDialog" :is-print="true" :is-create="false"></R010202>
    </el-dialog>

    <sendGradeNotification ref="sendGrade" @confirm-click="sendGradeNew"></sendGradeNotification>

  </div>
</template>

<script>

import common from '@/modules/common'
import R010202 from './R010202.vue'
import sendGradeNotification from '@/pages/components/sendGradeNotification.vue'
import JSZip from 'jszip'
import { saveAs } from 'file-saver'

export default {
  name: 'M060102',
  mixins: [common.mixins],
  components: {R010202, sendGradeNotification},
  data () {
    return {
      dialogTableVisible: false,
      pdfLoading: false,
      pdfPrintIndex: 0,
      pdfFile: [],
      pdfTabName: '',
      pdfPrintResult: 0,
      examInfo: {
        exam_seq: 0,
        exam_paper_seq: 0,
        exam_paper_title: '',
        cate_path: '',
        cate_code: '',
        curriculum_seq: '',
        curriculum_name: '',
        curriculum_yn: '',
        quiz_cnt: '',
        exam_type: '',
        exam_type_name: '',
        title: '',
        content: '',
        reg_dt: '',
        open_dt: '',
        close_dt: '',
        exam_term: '',
        stat_name: '',
        stat: '',
        exam_user_cnt: 0,
        exam_class_cnt: 0
      },
      classUserData: [],
      classUserColumns: [
        {label: '', prop: 'chk', align: 'center', type: 'selection'},
        {label: 'No', align: 'center', type: 'index'},
        {label: '클래스명', prop: 'class_name', align: 'left', width: 200},
        {label: '이름', prop: 'class_user_name', align: 'left', width: 100},
        {label: '응시여부', prop: 'stat_name', align: 'center', width: 80},
        {label: '답안지 제출일시', prop: 'submit_date', align: 'center', width: 150},
        {label: '점수', prop: 'exam_score', align: 'right', width: 80},
        {label: '백분위점수', prop: 'exam_score_100', align: 'right', width: 80, formatter: this.columnFormatterPrecision},
        {label: '석차', prop: 'exam_rank', align: 'right', width: 80},
        {label: '코멘트', prop: 'exam_comment_yn', align: 'center', width: 80},
        {label: '알림톡', prop: 'r_kakao_stat_name', align: 'center', width: 80}
      ],
      classUserProps: {height: this.getScreenHeight(31), rowClassName: this.membershipRowClassName},
      classUserSelection: [],
      examActionCol: {
        label: ' ',
        props: {
          align: 'center',
          width: 120
        },
        buttons: [{
          handler: row => {
            this.initPDFStat()
            this.openPDF(row)
          },
          props: {
            type: 'primary',
            size: 'mini'
          },
          label: 'PDF'
        }]
      }
    }
  },
  beforeCreate () {
  },
  created () {
    const examSeq = this.$route.params.exam_seq
    if (examSeq && examSeq !== 0) {
      this.loadInfo(examSeq)
    } else {
      this.$router.push({name: 'M060101'})
    }
  },
  computed: {
    pdfProgressbarRate: {
      get () {
        if (this.classUserSelection.length === 0) {
          return 0
        }
        return parseFloat((this.pdfPrintResult / this.classUserSelection.length * 100).toFixed(1))
      }
    },
    pdfProgressbarText: {
      get () {
        return this.pdfPrintResult + ' / ' + this.classUserSelection.length
      }
    },
    isPdfPrintDisabled: {
      get () {
        return this.classUserSelection.length === 0 || this.classUserSelection.length > 100
      }
    }
  },
  methods: {
    // 시험 정보 조회
    loadInfo (examSeq) {
      // this.loadStoneDataTable('/exam/load/' + examSeq, null, false)
      this.loadStoneDataTable('/exam/load/report/' + examSeq, {stat: 'S'})
        .then(response => {
          const result = response.data
          // console.log('result : ', result)
          Object.keys(this.examInfo).forEach(key => {
            this.examInfo[key] = this.isEmpty(result.exam[key]) ? '' : result.exam[key]
          })
          this.classUserData = result.exam_user
        })
    },
    classUserRowClickHandler (row, event, column) {
      if (column.property === 'chk' || column.label === ' ') {
        return
      }
      if (row.stat !== 'S') {
        this.$message.warning('미응시한 수강생은 성적표를 확인할 수 없습니다.')
        return
      }
      const param = {
        exam_seq: row.exam_seq,
        class_seq: row.class_seq,
        class_user_seq: row.class_user_seq
      }
      this.$router.push({name: 'M060103', params: param})
    },
    handleSelectionChange (value) {
      this.classUserSelection = value
      const dataTable = this.$refs.classUser.$refs.stoneDataTable.$refs.elTable
      this.classUserSelection.forEach(row => {
        if (row.stat !== 'S' || row.user_use_yn === 'N') {
          dataTable.toggleRowSelection(row, false)
        }
      })
    },
    sendGrade () {
      this.$confirm('성적표 알림톡을 발송하시겠습니까?', '', {})
        .then(() => {
          const classUser = this.classUserSelection.filter(x => x.stat === 'S' && x.user_use_yn === 'Y')
          common.axios.post('/exam/kakao/grade', {seq: this.examInfo.exam_seq, title: this.examInfo.title, users: classUser})
            .then(response => {
              const result = response.data
              if (result.status === 1) {
                this.$message('성적표가 발송되었습니다.')
                this.loadInfo(this.examInfo.exam_seq)
              } else {
                this.$message.warning(result.message)
              }
            })
        })
        .catch(() => {})
    },
    sendGradeNew (sendType) {
      const classUser = this.classUserSelection.filter(x => x.stat === 'S' && x.user_use_yn === 'Y')
      if (classUser.length === 0) {
        this.$message.warning('성적표 발송 대상을 선택하십시오.')
        return
      }
      common.axios.post('/exam/kakao/grade', {seq: this.examInfo.exam_seq, title: this.examInfo.title, users: classUser, send_type: sendType})
        .then(response => {
          const result = response.data
          if (result.status === 1) {
            this.$message('성적표가 발송되었습니다.')
            this.loadInfo(this.examInfo.exam_seq)
          } else {
            this.$message.warning(result.message)
          }
        })
    },
    handleCommand (command) {
      if (command === 'excel') {
        // 응시생 엑셀 다운로드
        this.downloadExcel()
      } else if (command === 'refresh') {
        // 새로고침
        this.loadInfo(this.examInfo.exam_seq)
      } else if (command === 'send') {
        this.handleSendGradeDialog()
      } else if (command === 'pdf') {
        this.handlePrintPDF()
      } else if (command === 'personal' || command === 'total') {
        this.initPDFStat()
        this.pdfTabName = 'tab-' + command
        this.handlePrintPDF()
      }
    },
    downloadExcel () {
      const param = {
        data: {
          service: 'ExamService',
          method: 'loadExamUser',
          params: {exam_seq: this.examInfo.exam_seq, stat: 'S', order: 'RANK'}
        },
        excel: {
          columns: this.classUserColumns,
          file: this.examInfo.title
        }
      }
      this.exportExcel(param)
    },
    handlePrintPDF () {
      this.openPDF(this.classUserSelection[this.pdfPrintIndex++], true)
    },
    initPDFStat () {
      this.pdfPrintIndex = 0
      this.pdfPrintResult = 0
      this.pdfFile = []
    },
    openPDF (row, isPrint = false) {
      // console.log('row : ', row)
      this.dialogTableVisible = true
      this.$nextTick(() => {
        this.$refs.printDialog.initPersonalPrint(row, isPrint, isPrint ? this.pdfTabName : 'tab-personal')
        if (isPrint) {
          this.pdfLoading = true
        }
      })
    },
    handlePDF () {
      this.pdfLoading = true
      this.$refs.printDialog.handlePDF()
    },
    completedPDF (isSuccess, pdf = null) {
      this.pdfLoading = false
      // console.log('isSuccess : ', isSuccess)
      // console.log('this.pdfPrintIndex : ' + this.pdfPrintIndex + ' / this.classUserSelection.length : ' + this.classUserSelection.length)
      if (isSuccess) {
        if (pdf != null) {
          this.pdfFile.push(pdf)
          this.pdfPrintResult++
          if (this.pdfPrintIndex < this.classUserSelection.length) {
            this.handlePrintPDF()
          } else {
            this.dialogTableVisible = false
            if (this.pdfFile.length > 0) {
              const zipFilename = []
              zipFilename.push(this.examInfo.title)
              zipFilename.push(this.pdfTabName === 'tab-personal' ? '개인' : '종합')
              zipFilename.push(this.formatterDate(new Date(), 'YYYYMMDD'))
              const zip = new JSZip()
              this.pdfFile.forEach(x => {
                zip.file(x.name, x.doc.output('blob'))
              })
              // console.log('zip : ', zip)
              zip.generateAsync({ type: 'blob' })
                .then(function (content) {
                  saveAs(content, zipFilename.join('_') + '.zip')
                })
            }
          }
        }
      } else {
        this.$message.error('PDF 생성에 실패하였습니다.')
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .progressbar-text {
    padding: 27px 0px;
    font-weight: bold;
    font-size: 24px;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/pages/M060102.vue